import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './registerServiceWorker'
import ElementUI from 'element-ui';
import { UTable, UTableColumn, UxGrid, UxTableColumn } from 'umy-ui'
// 注册全局自定义事件
import './assets/js/directives/common'

import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
//layim 聊天相关
import './assets/layui/css/layui.css'
import 'umy-ui/lib/theme-chalk/ux-grid.css'
import 'umy-ui/lib/theme-chalk/ux-table-column.css'

///富文本框
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'http://webapi.chehuijia.com.cn/api' : 'https://localhost:44349/api/'

// echarts
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')
require('echarts/lib/component/markLine')
require('echarts/lib/component/markPoint')
Vue.prototype.$echarts = echarts

// 弹幕
import {
    vueBaberrage
} from 'vue-baberrage'
Vue.use(vueBaberrage)

// 打印
import Print from 'vue-print-nb'

Vue.use(Print); //注册
// 三级联动
import 'vue-area-linkage/dist/index.css';
import VueAreaLinkage from 'vue-area-linkage';
Vue.use(VueAreaLinkage)
// 公共js
import util from './assets/js/common'
import socket from './assets/js/socket'
import lodop from './assets/js/LodopFuncs'
import socketPay from './assets/js/socket-pay'
import printHelper from './assets/js/printHelper'
Vue.prototype.$util = util
Vue.prototype.$socket = socket
Vue.prototype.$lodop = lodop
Vue.prototype.$socketPay = socketPay
Vue.prototype.$printHelper = printHelper
// 引入公用过滤器
import * as filters from './assets/js/filters.js'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(ElementUI);

// 按需引入umy-ui部分组件
Vue.use(UTable)
Vue.use(UTableColumn)
Vue.use(UxGrid)
Vue.use(UxTableColumn)

// 通过路由属性index判断当前active状态的nav
router.beforeEach((to, from, next) => {
    //取消之前所有尚未返回结果的请求
    store.commit('clearCancelToken')
    let noCheckLoginPage = (to.path == '/login' || to.path == '/forgetPwd' || to.path == '/registered/step1' || to.path == '/registered/step2' || to.path == '/registered/step3');
    let loginuser = util.getLocalStorage('userMsg');
    let Token = util.getCookie("Token");
    let Logged = loginuser && Token; //登录中

    //未登录
    if (!Logged) {
        if (store.state.connectState == 2) {
            socket.closeSocket()//断开客服连接
        }
        if (noCheckLoginPage) {
            next();
        } else {
            next({
                path: "/login",
            });
        }
    } else { //已登录
        if (noCheckLoginPage) {
            next({
                path: "/"
            });
        } else {
            //没发现有用到 qdl 2020/10/24
            // to.params.prevPath = from.path
            // let lastPage = {
            //     name: from.name,
            //     path: from.path
            // }
            // let currentPage = {
            //     name: to.name,
            //     path: to.params.prevPath
            // }
            // util.setLocalStorage('CurrentPage', currentPage)
            // util.setLocalStorage('LastPage', lastPage)
            next();
        }
    }
})
// 自定义指令 过滤特殊字符串
Vue.directive('filterSpecialChar', {
    update: function (el, {
        value,
        modifiers
    }, vnode) {
        try {
            let newValue = value ? value.replace(/[<>]/g, "") : '';

            if (value && (value !== newValue)) {
                util.warningMsg('不能输入特殊字符')
            }
            if (value !== newValue) {
                // 原生input
                if (el.value) {
                    el.value = newValue
                    el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
                }
                // element ui input
                else {
                    el.children[0].value = newValue
                    el.children[0].dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
                }
            }
        } catch (e) {
            //
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')